import React from "react";

const Bash_Cat = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Cat</h2>
      <p>Concatenate and display files.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>cat [file...]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>cat file.txt
cat file1.txt file2.txt > merged.txt</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>For long files, combine with | less.</p>
    </div>
  );
};

export default Bash_Cat;
